import { LookupItem } from "../lookup/models";
import { LookupItemDTO } from "./api-common-models";

export function toLookupItems<T>(apiLookupItems: LookupItemDTO<T>[]): LookupItem<T>[] {
  return apiLookupItems.map(i => {
    return {
      itemId: i.itemId,
      name: i.itemName,
      data: i.data,
      subItems: i.subItems ? toLookupItems(i.subItems) : []
    };
  });
}
